import script from "./MfaForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MfaForm.vue?vue&type=script&setup=true&lang=ts"

import "./MfaForm.vue?vue&type=style&index=0&id=68da7e5e&lang=css"

const __exports__ = script;

export default __exports__